import type { RouteRecordRaw } from 'vue-router'
const routes: RouteRecordRaw[] = [
  { path: '/merchant/login', name: 'merchantLogin', meta: { title: '沛奇走势图', merchant: true }, component: () => import('@/views/merchant/MerchantLogin.vue') },
  { path: '/trend-authorize', name: 'trendAuthorizeBridge', meta: { title: '授权走势图设备' }, component: () => import('@/views/merchant/MerchantAuthorizeBridge.vue') },
  {
    path: '/merchant', component: () => import('@/views/merchant/MerchantLayout.vue'), meta: { merchant: true }, children: [
      { path: '', name: 'merchantHome', meta: { title: '门店服务' }, component: () => import('@/views/merchant/MerchantHome.vue') },
      { path: 'trend', name: 'merchantTrend', meta: { title: '走势图管理' }, component: () => import('@/views/merchant/MerchantTrend.vue') },
      { path: 'authorize', name: 'merchantAuthorize', meta: { title: '授权走势图设备' }, component: () => import('@/views/mobileView/trendAuthorize.vue') },
      { path: 'account', name: 'merchantAccount', meta: { title: '我的账号' }, component: () => import('@/views/merchant/MerchantAccount.vue') },
      { path: ':pathMatch(.*)*', redirect: '/merchant' },
    ],
  },
]
export default routes
